class NearbyLocationsController {
  constructor(GeolocationService, GoogleMapService, JPMCService, UserDataService) {
    // Dependencies
    this.GeolocationService = GeolocationService;
    this.GoogleMapService = GoogleMapService;
    this.UserDataService = UserDataService;

    // Initial Values
    this.educatorList = JPMCService.getEducators();
    this.employerList = JPMCService.getEmployers();
    this.educators = [];
    this.employers = [];
    this.search = this.UserDataService.getAddress();
    console.log(this.search);

    // Run
    if(this.search) {
      this.getNearby()
    }
    else {
      this.getLocation();
    }
  }
  getLocation() {
    let self = this;
    let UserDataService = this.UserDataService;
    this.GeolocationService.getLocation().then((results) => {
      this.educators = this.GoogleMapService.calculateHavDistance(
        { lat: results.latitude, lng: results.longitude }, this.educatorList);
      this.employers = this.GoogleMapService.calculateHavDistance(
        { lat: results.latitude, lng: results.longitude }, this.employerList);
      this.GoogleMapService.convertLocation(results).then(function(address) {
        self.search = address.street;
        UserDataService.saveString('search',self.search);
      });
    }, (error) => {
      this.educators = this.GoogleMapService.calculateHavDistance(
        { lat: error.latitude, lng: error.longitude }, this.educatorList);
      this.employers = this.GoogleMapService.calculateHavDistance(
        { lat: error.latitude, lng: error.longitude }, this.employerList);
    });
  }
  getNearby() {
    var parent = this;
    if (this.search) {
      this.GoogleMapService.getLatLng(parent.search, this.educatorList).then(function(origin) {
        parent.educators = parent.GoogleMapService.calculateHavDistance(origin, parent.educatorList);
        parent.employers = parent.GoogleMapService.calculateHavDistance(origin, parent.employerList);
      });
    }
  }
  updateSearch() {
    var parent = this;
    let UserDataService = this.UserDataService;
    if (this.search) {
      this.GoogleMapService.getLatLng(parent.search, this.educatorList).then(function(origin) {
        parent.educators = parent.GoogleMapService.calculateHavDistance(origin, parent.educatorList);
        parent.employers = parent.GoogleMapService.calculateHavDistance(origin, parent.employerList);
      });
      UserDataService.saveString('search',this.search);
      /*this.GeolocationService.getLocation().then((results) => {
        parent.GoogleMapService.convertLocation(results).then(function(address) {
          parent.search = address.street;
          parent.UserDataService.saveUserData('search');
        });
      })*/
    }
  }
}

NearbyLocationsController.$inject = ['GeolocationService', 'GoogleMapService', 'JPMCService', 'UserDataService'];

export default NearbyLocationsController;



// WEBPACK FOOTER //
// ./src/components/nearbyLocations/nearbyLocations.controller.js